import React from "react";
import Navbar from "../LandingPage/TopSection/Navbar/Navbar";
import "./About.css";
import Banner from "./Banner";
import { Footer } from "../Footer/footer";
function About() {
  return (
    <>
      <Navbar />

      <br></br>
      <Banner />
      <Footer />
    </>
  );
}

export default About;
